import { computed, ComputedRef } from "vue";

import { composeEvent } from "./betData";
import formatedDate from "./lib/formatDate";

export default function composeDate(
  eventId: string | undefined,
  languageCode: string = navigator.language
): ComputedRef<string | undefined> {
  const event = composeEvent(eventId);

  return computed(() => {
    if (event.value?.live) {
      return formatedDate("live", languageCode);
    }
    if (event.value?.fixture) {
      return formatedDate(event.value?.fixture, languageCode);
    }
  });
}
